export default __webpack_public_path__ + "static/media/repeat.9d3235fb.svg";